export const daysApi = {
  days: {
    queryKey: (params?: string[]) => ["days", ...(params || [])],
    route: () => `days`,
    methods: ["GET", "POST"],
  },
  day: {
    queryKey: (id: number, params?: string[]) => [
      "days",
      id,
      ...(params || []),
    ],
    route: (id: number) => `days/${id}`,
    methods: ["PATCH", "DELETE"],
  },
};
